import React, { useState, useEffect, useRef } from 'react';
import { Modal, Input, InputNumber, Button, Checkbox, Tabs, message, Divider, Badge, Tooltip, Progress, Row, Col, Tag, DatePicker, List, Table } from 'antd';
import { BarcodeOutlined, PrinterOutlined, CloseOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import BarcodeScannerModal from './BarcodeScannerModal';
import { isAndroid } from '../utils/androidUtils';
import NotaCubagemModal from './NotaCubagemModal';
import './InclusaoNotasModal.css';
import apiService, { admin } from '../services/api';
import { useOnboard } from '../pages/Onboard/OnboardContext';
import { useOrganization } from '../contexts/OrganizationContext';
import printerService, { imprimir, verificaImpressora, onPrintProgress, enviarparaimpressora, enviarEtiquetaInicial, montarDtoEtiqueta } from '../services/printerService';
import notaanota from '../services/notaanota';
import PrinterSelection from './PrinterSelection';
import { useAuth } from '../contexts/AuthContext';

const { TextArea } = Input;

// Classe para estruturar os dados da Nota Fiscal
class NotaFiscal {
  constructor(chave = '', cnpj = '', nota = '', serie = '', notaFinal = '', dataInicial = '', dataFinal = '') {
    this.chave = chave;
    this.cnpj = cnpj;
    this.nota = nota;
    this.serie = serie;
    this.notaFinal = notaFinal;
    this.dataInicial = dataInicial;
    this.dataFinal = dataFinal;
  }

  // Método para validar se todos os campos obrigatórios estío preenchidos
  isValid() {
    // CNPJ é sempre obrigatório. Além dele, precisa de Nota ou Data (Inicial).
    const temCnpj = !!this.cnpj;
    const temNota = !!this.nota;
    const temData = !!this.dataInicial;

    return temCnpj && (temNota || temData);
  }

  // Método para limpar todos os dados
  clear() {
    this.chave = '';
    this.cnpj = '';
    this.nota = '';
    this.serie = '';
    this.notaFinal = '';
    this.dataInicial = '';
    this.dataFinal = '';
  }

  // Método para converter para JSON
  toJSON() {
    return {
      chave: this.chave,
      cnpj: this.cnpj,
      nota: this.nota,
      serie: this.serie,
      notaFinal: this.notaFinal,
      dataInicial: this.dataInicial,
      dataFinal: this.dataFinal
    };
  }
}

import NotaManutencaoModal from './NotaManutencaoModal';

const InclusaoNotasModal = ({ visible, onClose, prefillCode, notaEncontrada }) => {

  const { user } = useAuth();
  const { organizationId: orgIdFromContext } = useOrganization();
  // Funções Android importadas de androidUtils
  const {
    printerConnected,
    printerName,
    printerType,
    setPrinterConnected,
    setPrinterName,
    setPrinterDevice,
    setPrinterEmulator,
    // Nota atual vinda de contexto global (quando selecionada externamente)
    notaAtual,
    setNotaAtual,
    // Cliente atualmente selecionado no Onboard
    clienteSelecionado,
    veiculoDoDia,
    onboardData,
    buscarNotasTotais
  } = useOnboard();

  const [chaveNfe, setChaveNfe] = useState('');
  const [dados, setDados] = useState('');
  const [leituraContinua, setLeituraContinua] = useState(false);
  const [adicionarLista, setAdicionarLista] = useState(false);
  const [showAddListButton, setShowAddListButton] = useState(true);
  const [activeTab, setActiveTab] = useState('chave');

  useEffect(() => {
    try { printerService.setUser(user || null); } catch { }
  }, [user])



  // Debug para monitorar mudanças na aba ativa
  useEffect(() => {

  }, [activeTab]);
  const [scannerVisible, setScannerVisible] = useState(false);
  const [notaFiscalData, setNotaFiscalData] = useState(new NotaFiscal());
  const [notaData, setNotaData] = useState(null);
  const [cubagemOpen, setCubagemOpen] = useState(false);
  const inputRef = useRef(null);
  const [printerModalVisible, setPrinterModalVisible] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const lastSearchSignatureRef = useRef(null);
  const ignoreNextBlurRef = useRef(false);
  const [printing, setPrinting] = useState(false);
  const androidLeituraAtivaRef = useRef(false);
  const [printTotal, setPrintTotal] = useState(0);
  const [printCurrent, setPrintCurrent] = useState(0);
  const [reprintModalVisible, setReprintModalVisible] = useState(false);
  const [reprinting, setReprinting] = useState(false);
  const [volInicio, setVolInicio] = useState(null);
  const [volFim, setVolFim] = useState(null);
  const [reprintError, setReprintError] = useState('');
  const [manutencaoVisible, setManutencaoVisible] = useState(false);
  const [cepInfoModal, setCepInfoModal] = useState(null);
  const [ultimaAlteracao, setUltimaAlteracao] = useState(null);
  // Campos para busca por número (CNPJ, Nota, Série)
  const [cnpjNumero, setCnpjNumero] = useState('');
  const [notaNumero, setNotaNumero] = useState('');
  const [notaFinalNumero, setNotaFinalNumero] = useState('');
  const [serieNumero, setSerieNumero] = useState('');
  const [dataInicial, setDataInicial] = useState(null);
  const [dataFinal, setDataFinal] = useState(null);
  const [notasEncontradas, setNotasEncontradas] = useState([]);
  const [selectedNotas, setSelectedNotas] = useState([]);
  const [palavrasReservadas, setPalavrasReservadas] = useState([]);
  const [obsAlertVisible, setObsAlertVisible] = useState(false);
  const [obsAlertData, setObsAlertData] = useState([]);

  // Efeito para carregar as palavras reservadas ao montar o componente
  useEffect(() => {
    if (visible) {
      loadPalavrasReservadas();
    }
  }, [visible]);

  const loadPalavrasReservadas = async () => {
    try {
      // O endpoint correto para listar palavras é /v1/admin/palavras
      const data = await admin.getPalavras();
      setPalavrasReservadas(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erro ao carregar palavras reservadas:', error);
      setPalavrasReservadas([]);
    }
  };

  // Campos para inclusão manual
  const [cnpjManual, setCnpjManual] = useState('');
  const [notaManual, setNotaManual] = useState('');
  const [serieManual, setSerieManual] = useState('');
  const [cnpjDestManual, setCnpjDestManual] = useState('');
  const [cepDestManual, setCepDestManual] = useState('');
  const [volumesManual, setVolumesManual] = useState('');
  const [pesoManual, setPesoManual] = useState('');
  const [pedidoManual, setPedidoManual] = useState('');
  const [cepInvalido, setCepInvalido] = useState(false);

  // Áudios de feedback: ok ao encontrar, nok quando não encontra
  const okAudioRef = useRef(null);
  const nokAudioRef = useRef(null);
  const okAudioElRef = useRef(null);
  const nokAudioElRef = useRef(null);
  const audioUnlockedRef = useRef(false);

  // Efeito para sincronizar cnpjNumero com o cdremetente da nota carregada
  useEffect(() => {
    if (notaData?.cdremetente) {
      setCnpjNumero(notaData.cdremetente);
    }
  }, [notaData?.cdremetente]);

  // Componente reutilizável para exibir o cartío de dados
  const DadosCard = ({ info }) => {
    if (!info) {
      return <div className="dados-container">Nenhum dado disponível</div>;
    }

    return (
      <div className="dados-container">
        {/* Linha 1: Nota e Pedido à esquerda, ícone de edição à direita com cor por status */}
        <div
          className="dados-row1"
          style={{
            backgroundColor:
              info?.status === 0
                ? 'rgba(255, 77, 79, 0.35)'
                : info?.status === 1
                  ? '#52c41a22'
                  : 'transparent',
          }}
        >
          <div className="dados-row1-left">
            <div style={{ flex: '0 0 auto' }}>Nota: {String(info?.nota || '')}</div>
            <div className="dados-ped" title={String(info?.pedido || '')}>
              Ped: {String(info?.pedido || '')}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {info?.alteracao && (
              <Tag color={info.alteracao === 'CEP' ? 'green' : 'blue'}>
                Alterado: {info.alteracao}
              </Tag>
            )}
            {info?.status === 0 && (
              <Tooltip title="Editar nota/pedido">
                <EditOutlined
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#ffe58f',
                    border: '1px solid #faad14',
                    borderRadius: 0,
                    padding: '4px 6px',
                  }}
                  onClick={() => { try { setManutencaoVisible(true); } catch { } }}
                />
              </Tooltip>
            )}
          </div>
        </div>
        {/* Linha 2: Volumes, Peso e M3 com ícone ao lado do M3 */}
        <div className="dados-row2-grid">
          <div>Vol(s): {String(info?.volumes ?? '')}</div>
          <div>Peso: {String(info?.peso ?? '')}</div>
          <div className="dados-m3">
            <span>M3: {String(info?.m3 ?? '')}</span>
            <Tooltip title="Editar M3">
              <EditOutlined style={{ cursor: 'pointer' }} onClick={() => setCubagemOpen(true)} />
            </Tooltip>
          </div>
        </div>
        <Divider className="dados-divider" />
        <div className="dados-field-block">
          <div className="dados-field-label">Destinatário</div>
          <div className="dados-field-value" title={String(info?.destinatario || '')}>{String(info?.destinatario || '')}</div>

          <div style={{ backgroundColor: '#fffbe6', padding: '8px', borderRadius: '4px', border: '1px solid #ffe58f', marginTop: 8 }}>
            <Row gutter={8} align="middle">
              <Col flex="auto">
                <div className="dados-field-label" style={{ fontSize: '11px', marginBottom: 2 }}>Endereço</div>
                <div className="dados-field-text" title={String(info?.logradouro || info?.endereco || '')} style={{ marginTop: 0 }}>
                  {String(info?.logradouro || info?.endereco || '')}
                </div>
              </Col>
              <Col span={6}>
                <div className="dados-field-label" style={{ fontSize: '11px', marginBottom: 2 }}>Número</div>
                <div className="dados-field-text" style={{ marginTop: 0 }}>
                  {info?.nro ?? ''}
                </div>
              </Col>
            </Row>

            <div className="dados-field-block" style={{ marginTop: 8, marginBottom: 0 }}>
              <div className="dados-field-label">Cidade</div>
              <div className="dados-field-value">
                {String(info?.cep || '')} - {info?.cidade || ''}   - {info.uf}
              </div>
            </div>
          </div>
        </div>

        <div className="dados-bottom-grid">
          <div>ROTA: <strong>{String(info?.rota || '')}</strong></div>
          <div>SETOR: <strong>{info?.setor ?? ''}</strong></div>
          <div>CD: <strong>{String(info?.cd || '')}</strong></div>
        </div>
        <div style={{ padding: '0 12px 12px' }}>
          <Row gutter={[16, 8]}>
            <Col span={8}>
              <div style={{ fontSize: 12, color: '#666' }} className="label-responsive">NR1</div>
              <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} className="value-responsive">{info?.nr1 ?? ''}</div>
            </Col>
            <Col span={8}>
              <div style={{ fontSize: 12, color: '#666' }} className="label-responsive">NR2</div>
              <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} className="value-responsive">{info?.nr2 ?? ''}</div>
            </Col>
            <Col span={8}>
              {((info?.nr1 && info?.nr2 && info?.status === 1)) ? (
                <Button
                  type="default"
                  size="small"
                  shape="circle"
                  icon={<PrinterOutlined />}
                  style={{ backgroundColor: '#52c41a', color: '#fff', borderColor: '#52c41a' }}
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    const conectada = (!!printerName) || (printerConnected === true) || verificaImpressora();
                    if (!conectada) {
                      setReprintError('Impressora não definida');
                      setPrinterModalVisible(true);
                      return;
                    }
                    enviarEtiquetaInicial(info, info.nr1, info.nr2)
                      .then(() => { try { message.success('Etiqueta inicial enviada'); } catch { } })
                      .catch(() => { try { message.error('Falha ao enviar etiqueta'); } catch { } });
                  }}
                />
              ) : null}
            </Col>
          </Row>
        </div>
        {cubagemOpen && (
          <NotaCubagemModal
            open={cubagemOpen}
            onClose={() => setCubagemOpen(false)}
            notaInfo={notaData}
            onSaved={(res) => {
              try {
                setNotaData((prev) => ({ ...prev, m3: String(res?.totalM3 ?? prev?.m3 ?? '') }))
              } catch { }
            }}
          />
        )}
      </div>
    );
  };


  // Efeito para processar notaEncontrada quando for passada
  useEffect(() => {
    if (notaEncontrada) {
      //console.log(notaEncontrada)
      try {

        // Set chaveNfe com a chave da nota encontrada
        const chave = (notaEncontrada?.nota?.chave || notaEncontrada?.chave || '').replace(/\s+/g, '');
        if (chave) {
          setChaveNfe(chave);
        }

        // Set notaAtual com os dados da nota encontrada
        setNotaAtual(notaEncontrada);
        console.log(notaEncontrada)
        /*
        {
            "id": "cmiejl0de000f0r8san0wdrox",
            "chave": "42251050596790001917550110001601961450959333",
            "veiculoId": "cmhqtlpc200010ra8o77svav8",
            "usuarioId": "cmhulywyp00010r18guad4d76",
            "status": 1,
            "dtUso": "2025-11-25T00:00:00.000Z",
            "createdAt": "2025-11-25T09:18:31.749Z",
            "nota": {
                "chave": "42251050596790001917550110001601961450959333",
                "nota": 160196,
                "serie": "11",
                "volumes": "2",
                "peso": "19.35",
                "m3": "0.06",
                "pedido": "",
                "cdremetente": "50596790001917",
                "cddestinatario": "80666159000189",
                "rota": "JGS",
                "cd": "BLU",
                "setor": 0,
                "nr1": "00000486",
                "nr2": "00000489",
                "nro": 353,
                "cepentrega": "89252230",
                "destinatario": {
                    "nome": "FLORIANI EQUIP P/ESCRITORIO LTDAEPP",
                    "endereco": "R VENANCIO DA SILVA PORTO, 353",
                    "cidade": "JARAGUA DO SUL",
                    "uf": "SC"
                }
            },
            "remetenteNome": "RIO COM. E IND. DE PAPEIS LTDA"
        }
            */
        // Função auxiliar para garantir que valores sejam strings
        const safeString = (value) => {
          if (value === null || value === undefined) return '';
          if (typeof value === 'object') {
            // Se for um objeto simples, tentar extrair valor relevante
            if (value.nome) return String(value.nome);
            if (value.name) return String(value.name);
            if (value.value) return String(value.value);
            return ''; // Para objetos complexos, retornar vazio
          }
          return String(value);
        };

        // Debug dos valores individuais


        const info = {
          id: notaEncontrada.id || null,
          chave: safeString(notaEncontrada.nota?.chave || notaEncontrada.chave),
          cnpjrmte: safeString(notaEncontrada.nota?.cdremetente),
          remetente: safeString(notaEncontrada.nota?.remetente?.nome) || safeString(notaEncontrada.remetenteNome),
          nota: safeString(notaEncontrada.nota?.nota),
          serie: safeString(notaEncontrada.nota?.serie),
          pedido: safeString(notaEncontrada.nota?.pedido),
          volumes: safeString(notaEncontrada.nota?.volumes),
          peso: safeString(notaEncontrada.nota?.peso),
          m3: (() => {
            const d = notaEncontrada?.nota?.detalhe?.m3;
            const m = notaEncontrada?.nota?.m3;
            return safeString(d != null ? d : m);
          })(),
          destinatario: safeString(notaEncontrada.nota?.destinatario?.nome),
          cddestinatario: safeString(notaEncontrada.nota?.cddestinatario),
          endereco: safeString(notaEncontrada.nota?.destinatario?.logradouro || notaEncontrada.nota?.destinatario?.endereco),
          uf: safeString(notaEncontrada.nota?.destinatario?.uf || notaEncontrada.nota?.uf),
          nro: (() => {
            const vd = notaEncontrada?.nota?.nro;
            const vc = notaEncontrada?.nota?.destinatario?.nro;
            if (typeof vd === 'number') return vd;
            if (typeof vc === 'number') return vc;
            return null;
          })(),
          cep: safeString(notaEncontrada.nota?.cepentrega || notaEncontrada.nota?.destinatario?.cep || notaEncontrada.nota?.cep),
          cidade: safeString(notaEncontrada.nota?.destinatario?.cidade || notaEncontrada.nota?.cidade),
          rota: safeString(notaEncontrada.nota?.rota),
          setor: safeString(notaEncontrada.nota?.setor),
          cd: safeString(notaEncontrada.nota?.cd),
          placa: safeString(notaEncontrada.veiculo?.placa),
          nr1: safeString(notaEncontrada.nota.nr1),
          nr2: safeString(notaEncontrada.nota.nr2),
          status: (() => {
            const s = notaEncontrada?.status;
            if (s != null) return Number(s);
            const sd = notaEncontrada?.nota?.detalhe?.status;
            return sd != null ? Number(sd) : null;
          })()
        };


        setNotaData(info);

        // Se a cidade estiver vazia, tenta buscar os dados do cliente pelo CNPJ
        if (!info.cidade && info.cddestinatario) {
          apiService.clientes.getByCnpj(info.cddestinatario)
            .then(cliente => {
              if (cliente && (cliente.cidade || cliente.uf)) {
                setNotaData(prev => ({
                  ...prev,
                  cidade: prev.cidade || safeString(cliente.cidade),
                  uf: prev.uf || safeString(cliente.uf),
                  endereco: prev.endereco || safeString(cliente.logradouro || cliente.endereco),
                  cep: prev.cep || safeString(cliente.cep)
                }));
              }
            })
            .catch(err => console.error('Erro ao buscar dados do cliente por CNPJ:', err));
        }

        // Esconder botío "Adicionar a lista"
        setShowAddListButton(false);

      } catch (error) {
        console.error('Erro ao processar notaEncontrada:', error);
      }
    }
  }, [notaEncontrada, setNotaAtual]);

  // Debug para monitorar mudanças em notaEncontrada
  useEffect(() => {

  }, [notaEncontrada]);

  useEffect(() => {
    const unsubscribe = onPrintProgress((p) => {
      try { setPrintTotal(Number(p?.total || 0)); } catch { }
      try { setPrintCurrent(Number(p?.current || 0)); } catch { }
      if (p && p.done) {
        setPrinting(false);
      }
    });
    return () => { try { unsubscribe && unsubscribe(); } catch { } };
  }, []);



  // Desbloqueia reprodução de áudio a partir de uma interação do usuário
  const unlockAudioPlayback = () => {
    if (audioUnlockedRef.current) return;
    audioUnlockedRef.current = true;
    try {
      const ok = okAudioRef.current || okAudioElRef.current;
      okAudioRef.current = ok;
      ok.muted = true;
      // Tentar reproduzir silenciosamente para obter permissío
      ok.load?.();
      ok.play()
        .then(() => {
          ok.pause();
          ok.currentTime = 0;
          ok.muted = false;
        })
        .catch(() => {
          // Ignorar falha; continuará tentando nos próximos plays
          audioUnlockedRef.current = false; // permitir nova tentativa
        });

      const nok = nokAudioRef.current || nokAudioElRef.current;
      nokAudioRef.current = nok;
      nok.muted = true;
      nok.load?.();
      nok.play()
        .then(() => {
          nok.pause();
          nok.currentTime = 0;
          nok.muted = false;
        })
        .catch(() => {
          audioUnlockedRef.current = false;
        });
    } catch {
      audioUnlockedRef.current = false;
    }
  };

  // Função para executar busca e remover foco
  const executarBusca = async () => {

    if (chaveNfe && chaveNfe.length >= 44) {
      if (inputRef.current) {
        ignoreNextBlurRef.current = true;
      }


      try {
        const dados = await extraidadosdachave(chaveNfe);
        const nf = new NotaFiscal(chaveNfe, dados.cnpj || '', dados.nota || '', dados.serie || '');
        await setNotaFiscalData(nf);
        if (nf.isValid()) {
          try {
            setNotaData((prev) => ({
              ...(prev || {}),
              chave: chaveNfe,
              nota: dados.nota ?? prev?.nota,
              serie: dados.serie ?? prev?.serie,
              cnpjrmte: dados.cnpj ?? prev?.cnpjrmte,
            }));
          } catch { }
          setChaveNfe(chaveNfe);
          processaLeitura(nf)
        }
      } catch (e) {
        console.warn('Falha no onBlur da chave:', e);
      }



      // Ao executar, extrai dados da chave e busca nota
      buscanotapelachave(chaveNfe);
      // Remove o foco do input após executar a busca
      if (inputRef.current) {
        inputRef.current.blur();
      }




    }
  };

  // Listener para detectar mudanças no campo txtchave feitas pelo Android
  useEffect(() => {
    if (!visible) return; // Só configurar listeners quando o modal estiver visível

    const txtchaveElement = document.getElementById('txtchave');
    if (txtchaveElement) {
      let lastValue = txtchaveElement.value; // Armazenar o último valor para evitar loops

      const handleInputChange = () => {
        let newValue = txtchaveElement.value;
        // Eliminar espaços vazios se contiver
        if (newValue.includes(' ')) {
          newValue = newValue.replace(/\s+/g, '');
          txtchaveElement.value = newValue;
        }
        if (newValue !== lastValue) {
          lastValue = newValue;
          setChaveNfe(newValue);
          try { androidLeituraAtivaRef.current = false; } catch { }
        }
      };

      // Adicionar listeners para diferentes eventos
      txtchaveElement.addEventListener('input', handleInputChange);
      txtchaveElement.addEventListener('change', handleInputChange);

      // Observer para detectar mudanças no valor via JavaScript
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            handleInputChange();
          }
        });
      });

      observer.observe(txtchaveElement, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Verificar periodicamente se o valor mudou (fallback) - detecta mudanças na propriedade value
      const interval = setInterval(() => {
        handleInputChange();
      }, 500); // Reduzido para 500ms para detectar mudanças mais rapidamente

      // Expor funções globais para o WebView
      window.setChaveNfeFromWebView = (value) => {
        if (txtchaveElement && value) {
          const cleanValue = String(value).replace(/\s+/g, '');
          txtchaveElement.value = cleanValue;
          txtchaveElement.focus();
          // Disparar eventos para garantir que o React detecte a mudança
          txtchaveElement.dispatchEvent(new Event('input', { bubbles: true }));
          txtchaveElement.dispatchEvent(new Event('change', { bubbles: true }));
          // Atualizar o estado diretamente também
          setChaveNfe(cleanValue);
        }
      };

      // Expor função buscanotapelachave globalmente
      window.buscanotapelachave = buscanotapelachave;

      return () => {
        txtchaveElement.removeEventListener('input', handleInputChange);
        txtchaveElement.removeEventListener('change', handleInputChange);
        observer.disconnect();
        clearInterval(interval);
        // Limpar funções globais
        if (window.setChaveNfeFromWebView) {
          delete window.setChaveNfeFromWebView;
        }
        if (window.buscanotapelachave) {
          delete window.buscanotapelachave;
        }
      };
    }
  }, [visible]); // Recriar apenas quando o modal abrir/fechar

  // Prefill do código vindo externamente (scanner/Android via evento)
  useEffect(() => {
    if (visible && prefillCode && String(prefillCode).trim().length > 0) {
      const value = String(prefillCode).replace(/\s+/g, '');
      setChaveNfe(value);
      const el = document.getElementById('txtchave');
      if (el) {
        el.value = value;
        el.focus();
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Opcional: se tiver 44, executa busca imediatamente
      if (value.length >= 44) {
        try {
          // pequena defasagem para garantir que modal renderizou inputs
          setTimeout(() => {
            buscarnotapelachaveSafe(value)
          }, 150);
        } catch { }
      }
    }
  }, [visible, prefillCode]);

  // Prefill do CNPJ na aba "Número NF" ao abrir a modal, usando cliente selecionado
  useEffect(() => {
    try {
      if (visible && clienteSelecionado && clienteSelecionado.CdInscricao) {
        const cnpj = String(clienteSelecionado.CdInscricao);
        setCnpjNumero(cnpj);
      }
    } catch { }
  }, [visible, clienteSelecionado]);

  // Vincular refs dos elementos <audio> após montagem
  useEffect(() => {
    okAudioRef.current = okAudioElRef.current || null;
    nokAudioRef.current = nokAudioElRef.current || null;
  }, []);

  const buscarnotapelachaveSafe = async (value) => {
    try {
      if (typeof window.buscanotapelachave === 'function') {
        window.buscanotapelachave(value);
      } else {
        buscanotapelachave(value);
      }
    } catch (err) {
      console.warn('Falha ao acionar busca pela chave:', err);
    }
  };



  const handleBuscarManual = async () => {
    try {
      if (!cnpjManual || !notaManual || !serieManual || !cnpjDestManual || !volumesManual || !pesoManual) {
        message.warning('Preencha os campos obrigatórios: CNPJ Remetente, Nota, Série, CNPJ Destinatário, Volumes e Peso.');
        return;
      }

      // Preparar dados do veículo e filial
      const placaTitulo = veiculoDoDia?.placa || veiculoDoDia?.veiculo?.placa || onboardData?.vehicleData?.placa;
      const veiculoId = veiculoDoDia?.veiculo?.id || veiculoDoDia?.veiculoId || onboardData?.vehicleData?.id || null;

      let filialInt = (() => {
        const raw = user?.assignedBranch?.codigo ?? null;
        const n = raw == null ? NaN : parseInt(String(raw), 10);
        return Number.isNaN(n) ? null : n;
      })();
      if (filialInt == null && user?.assignedBranchId) {
        filialInt = user?.assignedBranch?.codigo ? parseInt(user.assignedBranch.codigo) : null;
      }
      if (filialInt == null) {
        const rawEmpresa = user?.empresa ?? null;
        const nEmpresa = rawEmpresa == null ? NaN : parseInt(String(rawEmpresa), 10);
        if (!Number.isNaN(nEmpresa)) filialInt = nEmpresa;
      }

      // Validação básica
      if (!veiculoId) {
        message.error('Veículo não identificado. Selecione um veículo.');
        return;
      }

      setIsSearching(true);
      setCepInvalido(false);

      const payload = {
        cnpjRemetente: cnpjManual,
        nota: notaManual,
        serie: serieManual,
        cnpjDestinatario: cnpjDestManual,
        cepDestinatario: cepDestManual,
        volumes: volumesManual,
        peso: Number(pesoManual),
        pedido: pedidoManual,
        veiculoId: veiculoId,
        branchId: filialInt,
        placa: placaTitulo,
        chave: chaveNfe,
        // Enviando dados da rota se disponíveis
        rota: cepInfoModal?.praca || undefined,
        cd: cepInfoModal?.cd || undefined,
        setor: cepInfoModal?.setor !== undefined ? Number(cepInfoModal.setor) : undefined
      };

      const data = await apiService.post('/v1/manual-inclusao', payload);

      if (data) {
        // Sucesso
        try {
          const a = okAudioRef.current || okAudioElRef.current || document.getElementById('ok_audio');
          if (a) {
            a.currentTime = 0;
            a.play().catch(() => { });
          }
        } catch { }

        message.success('Nota incluída com sucesso');

        // Atualizar campos com retorno
        if (data.cep) {
          setCepDestManual(data.cep);
          setCepInvalido(true); // Deixar com borda vermelha conforme solicitado
        }

        // Montar info para DadosCard
        const info = {
          chave: '',
          cnpjrmte: data.cdremetente,
          remetente: data.remetente,
          destinatario: data.destinatario,
          cddestinatario: data.cddestinatario,
          endereco: data.endereco,
          logradouro: data.logradouro,
          nro: data.nro,
          cidade: data.cidade,
          cep: data.cep,
          cd: data.cd,
          rota: data.rota,
          setor: data.setor,
          uf: data.uf,
          nota: notaManual,
          serie: serieManual,
          pedido: data.pedido,
          volumes: data.volumes,
          peso: data.peso,
          status: 0
        };

        setNotaData(info);

        // Se o CEP terminar com 000, disparar som not_ok e abrir modal manutenção
        if (data.cep && String(data.cep).endsWith('000')) {
          try {
            const a = nokAudioRef.current || nokAudioElRef.current || document.getElementById('notok_audio');
            if (a) {
              a.currentTime = 0;
              a.play().catch(() => { });
            }
          } catch { }
          setManutencaoVisible(true);
        }
      }

    } catch (error) {
      console.error('Erro busca manual:', error);
      const msg = error.response?.data?.message || error.message || 'Erro ao buscar/incluir nota manual';
      message.error(msg);

      try {
        const a = nokAudioRef.current || nokAudioElRef.current || document.getElementById('notok_audio');
        if (a) {
          a.currentTime = 0;
          a.play().catch(() => { });
        }
      } catch { }
    } finally {
      setIsSearching(false);
    }
  };

  const handleAdicionarSelecionadas = async () => {
    if (selectedNotas.length === 0) return;

    setIsSearching(true);
    let successCount = 0;
    let errorCount = 0;

    for (const item of selectedNotas) {
      try {
        const n = item.nota || {};
        const d = item.detalhe || {};
        const dest = item.destinatario || {};
        const cid = item.cidade || {};
        const rotaInfo = item.rota || null;

        const composed = {
          chave: n.chave || item.chave || '',
          nota: n.nota,
          serie: n.serie,
          pedido: n.pedido || '',
          volumes: Number(n.volumes ?? d.volumes ?? 0),
          peso: Number(n.peso ?? 0),
          m3: Number(n.m3 ?? 0),
          nr1: d.nr1 ?? 0,
          nr2: d.nr2 ?? 0,
          status: Number(d.status ?? 0),
          cdremetente: n.cdremetente,
          remetente: n.remetente?.nome || '',
          destinatario: dest.nome || '',
          endereco: dest.endereco || '',
          nro: (typeof d.nro === 'number' ? d.nro : (typeof dest.nro === 'number' ? dest.nro : null)),
          cidade: cid.nome ? `${cid.nome}-${cid.uf || ''}` : '',
          cep: n.cepentrega || '',
          cd: d.cd || (rotaInfo?.cd || ''),
          rota: d.rota || (rotaInfo?.rota || ''),
          setor: rotaInfo?.setor ?? null,
        };

        await handleAdicionarLista(composed);
        successCount++;
      } catch (err) {
        console.error('Erro ao adicionar nota selecionada:', err);
        errorCount++;
      }
    }

    setIsSearching(false);
    if (successCount > 0) {
      message.success(`${successCount} notas adicionadas com sucesso`);
      setSelectedNotas([]);
    }
    if (errorCount > 0) {
      message.error(`${errorCount} notas falharam ao ser adicionadas`);
    }
  };

  const handleReset = () => {
    setChaveNfe('');
    setDados('');
    setLeituraContinua(false);
    setAdicionarLista(false);
    setSelectedNotas([]);
  };

  const handleClose = () => {
    // Limpeza completa dos estados da modal ao fechar
    handleReset();
    try { setShowAddListButton(true); } catch { }
    setCnpjNumero('');
    setNotaNumero('');
    setSerieNumero('');

    // Reset Manual fields
    setCnpjManual('');
    setNotaManual('');
    setSerieManual('');
    setCnpjDestManual('');
    setCepDestManual('');
    setCepInvalido(false);
    setVolumesManual('');
    setPesoManual('');
    setPedidoManual('');

    setNotaFiscalData(new NotaFiscal());
    setNotaData(null);
    setScannerVisible(false);
    setActiveTab('chave');
    setPrinterModalVisible(false);
    setIsSearching(false);
    try { ignoreNextBlurRef.current = false; } catch { }
    try { lastSearchSignatureRef.current = null; } catch { }
    try { setNotaAtual(null); } catch { }
    onClose();
  };

  const handleOpenScanner = () => {
    setScannerVisible(true);
  };

  const handleScanResult = (decodedText, decodedResult) => {
    // Processa o resultado do scan
    if (decodedText && decodedText.trim()) {
      const cleanValue = decodedText.replace(/\s+/g, '');
      setChaveNfe(cleanValue);
      setScannerVisible(false);
      try {
        setTimeout(() => {
          const el = document.getElementById('txtchave');
          if (el) {
            try {
              const evtDown = new KeyboardEvent('keydown', { key: 'Tab', code: 'Tab', keyCode: 9, which: 9, bubbles: true });
              el.dispatchEvent(evtDown);
            } catch { }
            try { el.blur(); } catch { }
            try {
              const focusables = Array.from(document.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
                .filter(node => !node.disabled && node.tabIndex >= 0 && node.offsetParent !== null);
              const idx = focusables.indexOf(el);
              const next = idx >= 0 ? (focusables[idx + 1] || null) : null;
              if (next) { next.focus(); }
            } catch { }
            try {
              const evtUp = new KeyboardEvent('keyup', { key: 'Tab', code: 'Tab', keyCode: 9, which: 9, bubbles: true });
              el.dispatchEvent(evtUp);
            } catch { }
          }
        }, 0);
      } catch { }
      message.success('Código escaneado com sucesso!');
    }
  };

  const handleCloseScannerModal = () => {
    setScannerVisible(false);
  };

  const ler = () => {

    // Verificar se está rodando em Android
    if (isAndroid()) {
      try { if (androidLeituraAtivaRef.current) { return; } } catch { }
      try {
        if (typeof window.Android?.ler === 'function') {
          androidLeituraAtivaRef.current = true;
          window.Android.ler('txtchave', 'buscanotapelachave');
        } else {
          handleOpenScanner();
        }
      } catch (error) {
        console.error('Erro ao chamar Android.ler():', error);
        try {
          window.Android.ler();
        } catch (e2) {
          message.error('Erro ao acessar função Android');
        }
        try { androidLeituraAtivaRef.current = false; } catch { }
      }
    } else {
      handleOpenScanner();
    }
  };

  const buscanotapelachave = async (chave) => {
    if (!chave) {
      message.warning("Informe os 44 digitos da chave");
      throw new Error("Informe os 44 digitos da chave");
    }

    try {
      try { androidLeituraAtivaRef.current = false; } catch { }
      let dados = await extraidadosdachave(chave);

      // Criar nova instância da NotaFiscal com os dados extraídos
      const novaNotaFiscal = new NotaFiscal(
        chave,
        dados.cnpj || '',
        dados.nota || '',
        dados.serie || ''
      );

      // Atualizar o estado com a nova estrutura
      await setNotaFiscalData(novaNotaFiscal);

      // Validar se todos os dados necessários estío presentes
      if (!novaNotaFiscal.isValid()) {
        message.warning(`Chave: ${chave} - Cnpj, Nota ou Série estío faltando`);
        return;
      }

      //forçar envio de TAB elemento txtchave
      try {
        // Garantir que o campo controlado reflita a chave
        const cleanChave = String(chave).replace(/\s+/g, '');
        setChaveNfe(cleanChave);

        // Aguardar pequena margem para React aplicar o valor
        setTimeout(() => {
          const el = document.getElementById('txtchave');
          if (el) {
            // Disparar eventos de teclado Tab
            try {
              const evtDown = new KeyboardEvent('keydown', { key: 'Tab', code: 'Tab', keyCode: 9, which: 9, bubbles: true });
              el.dispatchEvent(evtDown);
            } catch { }

            // Forçar blur para acionar onBlur (que chama buscanotapelonumero)
            try { el.blur(); } catch { }

            // Opcional: focar próximo elemento focável simulando navegação por Tab
            try {
              const focusables = Array.from(document.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
                .filter(node => !node.disabled && node.tabIndex >= 0 && node.offsetParent !== null);
              const idx = focusables.indexOf(el);
              const next = idx >= 0 ? (focusables[idx + 1] || null) : null;
              if (next) {
                next.focus();
              }
            } catch { }

            try {
              const evtUp = new KeyboardEvent('keyup', { key: 'Tab', code: 'Tab', keyCode: 9, which: 9, bubbles: true });
              el.dispatchEvent(evtUp);
            } catch { }
          }
        }, 0);
      } catch { }

      return;

    } catch (e) {
      throw new Error(e);
    }
  };

  const extraidadosdachave = async (chave) => {
    chave = chave.trim();

    let dados = {
      cnpj: '',
      nota: '',
      serie: ''
    };

    if (chave.length === 44) {
      try {
        // 42240182640558000104550040004181861115355574
        // |______CNPJ__|  |S_|_NOTA__|
        // 01234567890123456789012345678901234567890123
        dados.cnpj = chave.substring(6, 20);
        dados.nota = parseInt(chave.substring(25, 34));
        dados.serie = parseInt(chave.substring(22, 25));

        // Atualizar os campos do formulário usando refs ou state
        const cnpjElement = document.getElementById('txt-cnpj-rmte');
        const notaElement = document.getElementById('txt-nota-rmte');
        const serieElement = document.getElementById('txt-serie-rmte');
        const cnpjManualElement = document.getElementById('txt-cnpj-rmte-manual');
        const notaManualElement = document.getElementById('txt-nota-rmte-manual');
        const serieManualElement = document.getElementById('txt-serie-rmte-manual');

        if (cnpjElement) cnpjElement.value = dados.cnpj;
        if (notaElement) notaElement.value = dados.nota;
        if (serieElement) serieElement.value = dados.serie;
        if (cnpjManualElement) cnpjManualElement.value = dados.cnpj;
        if (notaManualElement) notaManualElement.value = dados.nota;
        if (serieManualElement) serieManualElement.value = dados.serie;

      } catch (e) {
        console.error('Erro ao extrair dados da chave:', e);
      }

      return dados;
    }

    return dados;
  };

  const ok_audio = () => {
    try {
      const a = okAudioRef.current || okAudioElRef.current || document.getElementById('ok_audio');
      if (a) {
        a.currentTime = 0;
        a.play().catch(e => console.error('Erro ok_audio:', e));
      }
    } catch (e) {
      console.error('Erro em ok_audio helper:', e);
    }
  };

  const notok_audio = () => {
    try {
      const a = nokAudioRef.current || nokAudioElRef.current || document.getElementById('notok_audio');
      if (a) {
        a.currentTime = 0;
        a.play().catch(e => console.error('Erro notok_audio:', e));
      }
    } catch (e) {
      console.error('Erro em notok_audio helper:', e);
    }
  };

  const play_audio_wait = (caminho) => {
    return new Promise((resolve) => {
      try {
        const audioElement = document.getElementById('audio');
        if (!audioElement || !caminho) return resolve();

        let settled = false;
        const cleanup = () => {
          audioElement.removeEventListener('ended', onEnded);
          audioElement.removeEventListener('error', onError);
        };
        const settle = () => {
          if (settled) return;
          settled = true;
          cleanup();
          resolve();
        };
        const onEnded = () => settle();
        const onError = () => settle();

        audioElement.addEventListener('ended', onEnded, { once: true });
        audioElement.addEventListener('error', onError, { once: true });

        audioElement.src = caminho;
        audioElement.load();
        audioElement.play()
          .then(() => {
            // Timeout de segurança caso o evento 'ended' falhe
            setTimeout(settle, 12000);
          })
          .catch((err) => {
            console.error('Erro ao tocar áudio reservado:', err);
            settle();
          });
      } catch (error) {
        console.error('Erro em play_audio_wait:', error);
        resolve();
      }
    });
  };

  const buscanotapelonumero = async (notaFiscalData) => {

    if (!notaFiscalData) {
      message.error('Dados da Nota Fiscal incompletos para busca');
      return Promise.reject('Dados incompletos');
    }

    try {
      // Aqui você pode implementar a lógica de busca usando os dados da NotaFiscal
      let { chave, cnpj, nota, notaFinal, serie, dataInicial, dataFinal } = notaFiscalData.toJSON ? notaFiscalData.toJSON() : notaFiscalData;

      if (!cnpj) {
        message.error('Informe ao menos o CNPJ para buscar');
        return Promise.reject('Dados incompletos');
      }

      const signature = `${cnpj}|${nota}|${notaFinal}|${serie}|${dataInicial}|${dataFinal}`;
      const now = Date.now();
      const last = lastSearchSignatureRef.current;
      if (last && last.sig === signature && (now - last.ts) < 1000) {
        console.debug('Busca ignorada por duplicidade rápida:', signature);
        return Promise.resolve(notaFiscalData);
      }
      setIsSearching(true);
      lastSearchSignatureRef.current = { sig: signature, ts: now };

      // Monta query string dinâmica
      const params = new URLSearchParams();
      params.append('cnpj', cnpj);
      if (nota) params.append('nota', nota);
      if (notaFinal) params.append('notaFinal', notaFinal);
      if (serie) params.append('serie', serie);
      if (dataInicial) params.append('dataInicial', dataInicial);
      if (dataFinal) params.append('dataFinal', dataFinal);

      // Chama backend: /notas/buscar
      const result = await apiService.get(`/v1/notas/buscar?${params.toString()}`);

      // Se o resultado for um array, retornamos ele para ser tratado pelo chamador
      if (Array.isArray(result)) {
        if (result.length === 0) {
          throw new Error('Nenhuma nota encontrada');
        }
        setNotasEncontradas(result);
        setNotaData(null);
        return result;
      }

      // Se for um único objeto, processa normalmente
      setNotasEncontradas([]);
      const n = result?.nota || {};
      const d = result?.detalhe || {};
      const dest = result?.destinatario || {};
      const cid = result?.cidade || {};
      const cleanChave = (result?.nota?.chave || '').replace(/\s+/g, '');

      setChaveNfe(cleanChave)
      // Fallback rota via endpoint dedicado, se não veio
      let rotaInfo = result?.rota || null;
      try {
        if (!rotaInfo && n?.cepentrega) {
          const cleanCep = String(n.cepentrega).replace(/\D/g, '').padStart(8, '0');
          rotaInfo = await apiService.getRotasByCep(cleanCep);
        }
      } catch (e) {
        console.warn('Falhou ao buscar rota por CEP:', e?.message || e);
      }

      const composed = {
        chave: chave,
        nota: n?.nota ?? nota,
        serie: n?.serie ?? serie,
        pedido: n?.pedido || '',
        volumes: Number(n?.volumes ?? d?.volumes ?? 0),
        peso: Number(n?.peso ?? 0),
        m3: Number(n?.m3 ?? 0),
        nr1: result?.detalhe?.nr1 ?? 0,
        nr2: result?.detalhe?.nr2 ?? 0,
        status: Number(
          (result?.detalhe?.status ?? 0)
        ),
        cdremetente: n?.cdremetente,
        remetente: n?.remetente?.nome || '',
        destinatario: dest?.nome || '',
        endereco: dest?.endereco || '',
        nro: (typeof d?.nro === 'number' ? d?.nro : (typeof dest?.nro === 'number' ? dest?.nro : null)),
        cidade: cid?.nome ? `${cid.nome}-${cid.uf || ''}` : '',
        cep: n?.cepentrega || '',
        cd: d?.cd || (rotaInfo?.cd || ''),
        rota: d?.rota || (rotaInfo?.rota || ''),
        setor: rotaInfo?.setor ?? null,
        obs: result?.nota?.obs || result?.detalhe?.obs || result?.obs || '',
      };

      setNotaData(composed);
      setShowAddListButton(true);


      return composed;

    } catch (error) {
      console.error('Erro na busca da nota fiscal:', error);
      const msg = String(error?.message || '').toLowerCase();
      if (msg.includes('nota não encontrada')) {
        message.warning('Nota fiscal não cadastrada - redirecionando para inclusão manual');

        // Tocar áudio de falha apenas quando não encontrou
        try {
          const a = nokAudioRef.current || nokAudioElRef.current;
          if (a) {
            a.currentTime = 0;
            a.play().catch(() => { });
          }
        } catch { }

        // Auto-preenchimento da aba Manual
        try {
          const chaveParaExtrair = notaFiscalData?.chave || chaveNfe;
          if (chaveParaExtrair && chaveParaExtrair.length === 44) {
            const dadosExtraidos = await extraidadosdachave(chaveParaExtrair);

            if (dadosExtraidos.cnpj) setCnpjManual(dadosExtraidos.cnpj);
            if (dadosExtraidos.nota) setNotaManual(String(dadosExtraidos.nota));
            if (dadosExtraidos.serie) setSerieManual(String(dadosExtraidos.serie));

            setActiveTab('manual');
          }
        } catch (e) {
          console.warn('Falha ao extrair dados para manual:', e);
        }

      } else {
        message.error('Erro ao buscar nota fiscal');
      }
      throw error;
    } finally {
      setIsSearching(false);
    }
  };

  // Processa leitura: busca por número e, se sucesso e leitura contínua ativa,
  // adiciona à lista e inicia nova leitura
  const processaLeitura = async (nf) => {
    try {
      const nfDados = await buscanotapelonumero(nf);
      if (nfDados) {
        await handleAdicionarLista(nfDados);
        // verificar palavras 
        let obs = nfDados.obs;

        if (obs) {
          const palavrasEncontradas = [];
          const obsTexto = String(obs || '').toLowerCase();

          for (const item of (Array.isArray(palavrasReservadas) ? palavrasReservadas : [])) {
            const palavra = String(item?.palavra ?? item?.Palavra ?? '').trim();
            if (!palavra) continue;

            const index = obsTexto.indexOf(palavra.toLowerCase());
            if (index !== -1) {
              // Extrair a palavra original + 50 caracteres
              const originalObs = String(obs || '');
              const trecho = originalObs.substring(index, index + palavra.length + 50);

              palavrasEncontradas.push({
                ...item,
                textoEncontrado: trecho
              });
            }
          }

          if (palavrasEncontradas.length > 0) {
            setObsAlertData(palavrasEncontradas);
            setObsAlertVisible(true);

            // Registrar no histórico do backend
            try {
              const payload = {
                chave: nfDados.chave,
                palavras: palavrasEncontradas.map(p => ({
                  palavra: p.palavra || p.Palavra,
                  textoEncontrado: p.textoEncontrado
                }))
              };
              apiService.post('/v1/notas/registrar-palavras', payload).catch(err => {
                console.error('Erro silencioso ao registrar histórico de palavras:', err);
              });
            } catch (historyErr) {
              console.warn('Falha ao preparar registro de histórico:', historyErr);
            }

            for (const item of palavrasEncontradas) {
              const audioPath = item?.audio ?? item?.Audio;
              if (audioPath) {
                await play_audio_wait(audioPath);
              }
            }
          } else {
            ok_audio();
          }
        } else {
          ok_audio();
        }

        if (leituraContinua === true) {
          try { androidLeituraAtivaRef.current = false; } catch { }
          ler();
        }

      }
      return true;
    } catch (e) {
      return false;
    }
  };

  // Handler customizado para busca dinâmica (CNPJ, Notas, Datas)
  const handleBuscarDinamico = async () => {
    const cnpj = String(cnpjNumero).replace(/[^a-zA-Z0-9]/g, '');
    const notaIni = String(notaNumero).replace(/\D/g, '');
    const notaFim = String(notaFinalNumero).replace(/\D/g, '');
    const serie = String(serieNumero).replace(/\D/g, '');
    const dIni = dataInicial ? toLocalYYYYMMDD(dataInicial.toDate()) : '';
    const dFim = dataFinal ? toLocalYYYYMMDD(dataFinal.toDate()) : '';

    if (!cnpj) {
      message.error('O CNPJ é obrigatório para realizar a busca');
      return;
    }

    if (!notaIni && !dIni) {
      message.error('Informe ao menos a Nota Inicial ou a Data Inicial para filtrar a busca');
      return;
    }

    try {
      setIsSearching(true);
      setNotasEncontradas([]);
      setNotaData(null);

      const params = new URLSearchParams();
      params.append('cnpj', cnpj);
      if (notaIni) params.append('nota', notaIni);
      if (notaFim) params.append('notaFinal', notaFim);
      if (serie) params.append('serie', serie);
      if (dIni) params.append('dataInicial', dIni);
      if (dFim) params.append('dataFinal', dFim);

      // Chama o endpoint diretamente para evitar validações fixas de outras funções
      const result = await apiService.get(`/v1/notas/buscar-dinamica?${params.toString()}`);

      if (Array.isArray(result)) {
        if (result.length === 0) {
          message.warning('Nenhuma nota encontrada com os filtros informados');
        } else {
          setNotasEncontradas(result);
          setSelectedNotas([]); // Limpa seleção ao buscar novas notas
        }
      } else if (result && typeof result === 'object') {
        // Se retornar apenas um objeto, transforma em array para a lista ou processa direto
        const singleResult = [result];
        setNotasEncontradas(singleResult);
        setSelectedNotas([]); // Limpa seleção ao buscar novas notas

        // Se for um único resultado e leitura automática/adicionar lista estiver ativa, processa
        if (leituraContinua || adicionarLista) {
          // Aqui precisaríamos converter o objeto para o formato que handleAdicionarLista espera
          // mas como o usuário quer a lista, vamos apenas mostrar na lista primeiro
        }
      }
    } catch (error) {
      console.error('Erro na busca dinâmica:', error);
      const msg = error.message || 'Erro ao buscar notas';
      message.error(msg);
    } finally {
      setIsSearching(false);
    }
  };



  const toLocalYYYYMMDD = (date) => {
    try {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    } catch {
      return '';
    }
  };



  const handleUpdateNro = async (newNro) => {
    if (!notaData?.id) return;

    try {
      await apiService.notaVeiculoUso.update(notaData.id, { nro: newNro });
      message.success('Número atualizado');
    } catch (err) {
      console.error('Erro ao atualizar número:', err);
      message.error('Falha ao atualizar número');
    }
  };

  const handleAdicionarLista = async (nfDados) => {

    try {
      const placaTitulo = veiculoDoDia?.placa || veiculoDoDia?.veiculo?.placa || onboardData?.vehicleData?.placa;
      if (!placaTitulo) {
        try { const a = document.getElementById('notok_audio'); a && a.play && a.play().catch(() => { }); } catch { }
        message.error('Selecione o veículo antes de adicionar notas.');

        return;
      }

      const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
      const dia = toLocalYYYYMMDD(hoje);
      const chave = String(nfDados?.chave || '').trim();
      if (!chave) {
        message.error('Chave NF-e é obrigatória.');
        return;
      }

      const usuarioId = user?.id || null;
      if (!usuarioId) {
        message.error('Falha: usuário não identificado. Faça login novamente.');
        return;
      }

      let filialInt = (() => {
        const raw = user?.assignedBranch?.codigo ?? null;
        const n = raw == null ? NaN : parseInt(String(raw), 10);
        return Number.isNaN(n) ? null : n;
      })();
      if (filialInt == null && user?.assignedBranchId) {
        try {
          const branches = await apiService.admin.getBranches();
          const found = Array.isArray(branches) ? branches.find(b => b.id === user.assignedBranchId) : null;
          const codigoNum = found?.codigo == null ? NaN : parseInt(String(found.codigo), 10);
          filialInt = Number.isNaN(codigoNum) ? null : codigoNum;
        } catch { }
      }
      if (filialInt == null) {
        const rawEmpresa = user?.empresa ?? null;
        const nEmpresa = rawEmpresa == null ? NaN : parseInt(String(rawEmpresa), 10);
        if (!Number.isNaN(nEmpresa)) filialInt = nEmpresa;
      }
      if (filialInt == null) {
        message.error('Filial do usuário sem código numérico. Verifique seu perfil.');
        return;
      }

      const veiculoId = veiculoDoDia?.veiculo?.id || veiculoDoDia?.veiculoId || onboardData?.vehicleData?.id || null;
      const organizationId = orgIdFromContext || user?.organizationId || null;
      if (!veiculoId || !organizationId) {
        const miss = [];
        if (!veiculoId) miss.push('veiculoId');
        if (!organizationId) miss.push('organizationId');
        message.error(`Campos obrigatórios ausentes: ${miss.join(', ')}`);
        throw new Error(`Campos obrigatórios ausentes: ${miss.join(', ')}`);
      }

      const resp = await apiService.notaVeiculoUso.create({
        chave,
        placa: placaTitulo,
        dia,
        status: 0,
        usuarioId,
        filial: filialInt,
        veiculoId,
        organizationId,
        cdremetente: nfDados?.cdremetente || nfDados?.cnpj,
        assignedBranchId: user?.assignedBranch?.id || user?.assignedBranchId || null,
        cepentrega: nfDados.cep,
        volumes: nfDados.volumes,
        peso: nfDados.peso,
        m3: nfDados.m3,
        rota: nfDados.rota,
        cd: nfDados.cd,
        setor: nfDados.setor,
        nro: nfDados.nro
      });

      if (resp && (resp.ok === false || resp.error || resp.status === 'error')) {
        try { const a = document.getElementById('notok_audio'); a && a.play && a.play().catch(() => { }); } catch { }
        const errMsg = String(resp.error || resp.message || 'Falha ao incluir nota');
        throw new Error(errMsg);
      }

      if (leituraContinua === false) {
        try {
          setNotaData(prev => ({ ...(prev || {}), nr1: resp?.nr1, nr2: resp?.nr2 }));
        } catch { }
      }

      try {
        const a = okAudioRef.current || okAudioElRef.current || document.getElementById('ok_audio');
        if (a) {
          a.currentTime = 0;
          a.play().catch(() => { });
        }
      } catch { }
      setChaveNfe('');
      setShowAddListButton(false);

    } catch (err) {
      const msg = String(err?.message || '').toLowerCase();
      if (msg.includes('duplic')) {
        message.warning('Nota já consta na lista para hoje.');
      } else {
        message.error(err?.message || 'Falha ao incluir nota. Verifique a chave.');
      }
      try { const a = document.getElementById('notok_audio'); a && a.play && a.play().catch(() => { }); } catch { }
      throw err;
    }
  };

  // Função auxiliar para aviso (substitui showAlertWarn do legado)
  const showAlertWarn = (msg) => {
    try { message.warning(msg); } catch { alert(msg); }
  };




  const chamaImpressora = async () => {
    try {
      const notaEmUso = notaData || null;

      const chave = ((chaveNfe || '').trim())
        || String(notaEmUso?.chave || '').trim();

      const filialRaw = user?.assignedBranch?.codigo;
      const filialInt = filialRaw == null ? NaN : parseInt(String(filialRaw), 10);
      const raw = notaEmUso || {};
      const destinatario = {
        nome: String(raw?.destinatario?.nome || raw?.destinatario || clienteSelecionado?.DsEntidade || '').trim(),
        endereco: String(raw?.destinatario?.endereco || raw?.destinatario?.logradouro || raw?.endereco || clienteSelecionado?.DsEndereco || clienteSelecionado?.Endereco || '').trim(),
        nro: (raw?.destinatario?.nro ?? raw?.nro ?? ''),
        cidade: String(raw?.destinatario?.cidade || raw?.cidade || clienteSelecionado?.DsCidade || clienteSelecionado?.Cidade || '').trim(),
        uf: String(raw?.destinatario?.uf || raw?.uf || clienteSelecionado?.DsUF || clienteSelecionado?.UF || '').trim(),
        cnpj: String(raw?.destinatario?.cnpj || raw?.cddestinatario || '').trim(),
      };
      const remetente = String(raw?.remetente?.nome || raw?.remetente || '').trim()
      const notaVal = (raw?.nota ?? raw?.numero ?? '');
      const serieVal = (raw?.serie ?? '');
      const cepEntrega = String(raw?.cepentrega || raw?.cep || clienteSelecionado?.CdCep || clienteSelecionado?.Cep || '').trim();

      const nr1Val = raw?.nr1 ?? raw?.detalhe?.nr1 ?? null;
      const nr2Val = raw?.nr2 ?? raw?.detalhe?.nr2 ?? null;
      const volsVal = Number((raw?.volumes ?? raw?.detalhe?.volumes ?? 0) || 0);
      const rotaVal = raw?.rota ?? raw?.detalhe?.rota ?? raw?.destino?.rota ?? raw?.destinatario?.rota ?? '';
      const cdVal = raw?.cd ?? raw?.detalhe?.cd ?? '';
      const setorVal = raw?.setor ?? raw?.detalhe?.setor ?? '';
      const cddestinatarioVal = raw?.cddestinatario ?? destinatario?.cnpj ?? clienteSelecionado?.CdInscricao ?? '';
      const cdremetenteVal = raw?.cdremetente ?? raw?.remetente?.cnpj ?? '';

      const notaForPrint = {
        ...raw,
        remetente,
        destinatario,
        nota: notaVal,
        serie: serieVal,
        cepentrega: cepEntrega,
        cddestinatario: cddestinatarioVal,
        cdremetente: cdremetenteVal,
        detalhe: {
          nr1: nr1Val,
          nr2: nr2Val,
          volumes: volsVal,
          rota: rotaVal,
          cd: cdVal,
          setor: typeof setorVal === 'number' ? setorVal : (setorVal ? parseInt(String(setorVal), 10) : undefined),
          uf: destinatario?.uf || '',
        },
      };

      const printerNameForPayload = printerService?.printerName || printerName || null;
      const payload = {
        printername: printerNameForPayload,
        impressora: printerNameForPayload,
        usuarioId: user?.id || null,
        organizationId: orgIdFromContext || user?.organizationId || null,
        assignedBranchId: user?.assignedBranchId || user?.assignedBranch?.id || null,
        filial: Number.isInteger(filialInt) ? filialInt : undefined,
        chaveNfe: chave,
        placa: veiculoDoDia?.veiculo?.placa || veiculoDoDia?.placa || onboardData?.vehicleData?.placa || null,
        veiculoId: veiculoDoDia?.veiculo?.id || veiculoDoDia?.veiculoId || null,
        rota: rotaVal || undefined,
        cd: cdVal || undefined,
        setor: typeof setorVal === 'number' ? setorVal : (setorVal ? parseInt(String(setorVal), 10) : undefined),
        cepentrega: cepEntrega || undefined,
        nota: notaForPrint,
      };

      setPrinting(true);
      try {
        const vt = Number((notaEmUso?.nota?.volumes ?? notaEmUso?.volumes ?? 0) || 0);
        setPrintTotal(vt);
        setPrintCurrent(0);
      } catch { }

      /*
      if (!nr1Val || !nr2Val) {
        showAlertWarn('NR1/NR2 ausentes. Primeiro, adicione a nota à lista.');
        setPrinting(false);
        return false;
      }
      */

      imprimir(payload)
        .then((res) => {
          try {
            setNotaData((prev) => (prev ? { ...prev, status: 1, nr1: res?.nr1 ?? prev.nr1, nr2: res?.nr2 ?? prev.nr2 } : prev));
          } catch { }
        })
        .catch(err => {
          const msg = (err && err.message) ? err.message : 'Falha ao imprimir';
          showAlertWarn(msg);
        })
        .finally(() => { setPrinting(false); })

      return true;
    } catch (err) {
      const msg = (err && err.message) ? err.message : 'Erro ao imprimir nota';
      showAlertWarn(msg);
      return false;
    }
  }

  const reimprimir = async () => {
    try {
      const n = notaData || null;
      const total = Number((n?.nota?.volumes ?? n?.volumes ?? 0) || 0);
      setVolInicio(total > 0 ? 1 : null);
      setVolFim(total > 0 ? total : null);
      setReprintError('');
      setReprintModalVisible(true);
      return true;
    } catch (err) {
      const msg = (err && err.message) ? err.message : 'Erro ao abrir reimpressão';
      showAlertWarn(msg);
      return false;
    }
  };

  const confirmarReimpressao = async () => {
    //console.log(notaData)
    const n = notaData || null;
    const total = Number((n?.nota?.volumes ?? n?.volumes ?? 0) || 0);
    const vi = parseInt(volInicio, 10);
    const vf = parseInt(volFim, 10);
    if (!n || !total || Number.isNaN(vi) || Number.isNaN(vf)) {
      setReprintError('Dados inválidos');
      return;
    }
    if (vi < 1 || vf < 1 || vi > vf || vf > total) {
      setReprintError('Intervalo inválido');
      return;
    }
    const conectada = (!!printerName) || (printerConnected === true) || verificaImpressora();
    if (!conectada) {
      setReprintError('Impressora não definida');
      setPrinterModalVisible(true);
      return;
    }
    setReprintError('');
    setReprinting(true);
    try {
      const chave = String(n?.chave || '').trim();
      const cnpj = String(n?.cdremetente || n?.cddestinatario || '').trim() || null;
      const notaNum = n?.nota ?? null;
      const serieStr = n?.serie ?? null;
      try {
        await notaanota.registrarReimpressao({
          chave,
          cnpj,
          nota: notaNum,
          serie: serieStr,
          volInicio: vi,
          volFim: vf,
          usuario: user?.id || user?.codigo || null,
          veiculoId: (veiculoDoDia?.veiculo?.id || onboardData?.vehicleData?.id || null),
        });
      } catch { }


      for (let v = vi; v <= vf; v++) {
        const dados = await notaanota.getDadosReimpressao(chave, v);
        /*
        {
            "nr1": "00000486",
            "sequencial": 488,
            "volume": "2",
            "detalhe": {
                "chave": "42251050596790001917550110001601961450959333",
                "cepentrega": "89252230",
                "rota": "JGS",
                "cd": "BLU",
                "setor": 0,
                "volumes": 2,
                "nro": 353,
                "nr1": "00000486",
                "nr2": "00000489",
                "filial": 999999,
                "brancheid": "cmej3t6r900080rige4rusxnt",
                "veiculoId": "cmhqtlpc200010ra8o77svav8",
                "status": 1,
                "natureza": null,
                "peso": 19.35,
                "m3": 0.06,
                "userId": "cmhulywyp00010r18guad4d76",
                "createdAt": "2025-11-25T09:11:04.562Z",
                "updatedAt": "2025-11-25T12:18:54.170Z",
                "updatedAtByUserId": "cmhulywyp00010r18guad4d76"
            }
        }        */
        const sequencial = Number(dados?.sequencial || 0);
        const detalhe = dados?.detalhe || {};
        const baseNota = n || {};
        const notaParaImprimir = {
          ...baseNota,
          rota: detalhe?.rota ?? baseNota?.rota ?? '',
          cd: detalhe?.cd ?? baseNota?.cd ?? '',
          setor: detalhe?.setor ?? baseNota?.setor ?? '',
          peso: detalhe?.peso ?? baseNota?.peso ?? '',
          m3: detalhe?.m3 ?? baseNota?.m3 ?? '',
          remetente: n?.remetente,
          cddestinatario: n?.cddestinatario
        };

        console.log(notaParaImprimir)

        const dto = montarDtoEtiqueta(notaParaImprimir, {
          volumeAtual: String(v),
          volumeTotal: String(vf),
          sequencial: String(sequencial),

          reimpressao: true,
        });

        await enviarparaimpressora(dto);
      }

      setReprintModalVisible(false);
    } catch (e) {
      setReprintError((e && e.message) ? e.message : 'Erro na reimpressão');
    } finally {
      setReprinting(false);
    }
  };


  // Status e ações da impressora (similar ao Footer)
  const getPrinterStatus = () => {
    if (printerConnected) {
      return { status: 'success', text: `Conectada: ${printerName || 'Impressora'}` };
    }
    if (printerType) {
      return { status: 'warning', text: `Tipo selecionado: ${printerType}` };
    }
    return { status: 'error', text: 'Impressora não configurada' };
  };

  const desconectarImpressora = async () => {
    try {
      await printerService.disconnect();
      setPrinterConnected(false);
      setPrinterName(null);
      setPrinterDevice(null);
      setPrinterEmulator(null);
    } catch (err) {
      console.error('Erro ao desconectar impressora:', err);
    }
  };

  const printerStatus = getPrinterStatus();
  const statusNota = (notaData && notaData.status != null) ? notaData.status : null;

  return (
    <Modal
      title="Inclusão de Notas"
      open={visible}
      onCancel={handleClose}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          {printing && (
            <div style={{ flex: 1 }}>
              <Progress percent={printTotal > 0 ? Math.round((printCurrent / printTotal) * 100) : 0} format={() => `${printCurrent}/${printTotal}`} />
            </div>
          )}
          {leituraContinua !== true && showAddListButton && notaData && (
            <Button
              type="primary"
              onClick={() => handleAdicionarLista(notaData)}
              style={{ backgroundColor: '#5b5bff' }}
            >
              Adicionar a lista
            </Button>
          )}
          {(statusNota !== 1) && (
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={() => chamaImpressora()}
              disabled={printing}
              loading={printing}
              style={{ backgroundColor: '#52c41a' }}
            >
              Imprimir
            </Button>
          )}
          {statusNota === 1 && (
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={reimprimir}
              style={{ backgroundColor: '#1890ff' }}
            >
              Reimprimir
            </Button>
          )}
        </div>
      )}
      width={500}
      closeIcon={<CloseOutlined />}
      className="inclusao-notas-modal"
      style={{ top: 0 }}
      styles={{
        content: {
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        },
        body: {
          flex: 1,
          overflowY: 'auto'
        }
      }}
      maskClosable={false}
    >
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 8 }}>
          {printerName && (
            <span style={{ fontWeight: 500 }}>{printerName}</span>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tooltip title={printerStatus.text} placement="top">
              <div
                className={`footer-printer-small ${!printerConnected && !printerType ? 'no-printer' : ''}`}
                onClick={() => { if (!printerConnected) setPrinterModalVisible(true); }}
              >
                <Badge dot status={printerStatus.status}>
                  <PrinterOutlined style={{ fontSize: 20 }} />
                </Badge>
              </div>
            </Tooltip>
            {printerConnected && (
              <Button type="link" size="small" onClick={desconectarImpressora} style={{ color: '#ff4d4f' }}>
                Desconectar
              </Button>
            )}


          </div>

        </div>
      </div>

      <Modal
        title="Selecionar Impressora"
        open={printerModalVisible}
        maskClosable={false}
        onCancel={() => {
          setPrinterModalVisible(false);
        }}

        footer={null}
        width={600}
        centered
      >
        <PrinterSelection onPrinterConnect={() => {
          setPrinterModalVisible(false);
        }} />
      </Modal>

      <Modal
        title="Reimpressão de etiquetas"
        open={reprintModalVisible}
        onCancel={() => { setReprintModalVisible(false); setReprintError(''); }}
        footer={null}
        width={520}
        centered
        zIndex={1075}
        maskClosable={false}
      >
        <div style={{ marginBottom: 12 }}>
          <Row gutter={[8, 8]}>
            <Col span={12}>
              <div style={{ borderLeft: '4px solid #1677ff', paddingLeft: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 600 }}>Nota: <span>{String((notaData?.nota ?? '') || '')}</span></div>
                <div style={{ borderBottom: '1px solid #f0f0f0', margin: '6px 0' }}></div>
                <div style={{ fontSize: 12, textAlign: 'center' }}>Destinatário</div>
                <div style={{ color: '#595959', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {String((notaData?.destinatario ?? '') || '')}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ borderLeft: '4px solid #ff4d4f', paddingLeft: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 600 }}>Pedido: <span>{String((notaData?.pedido ?? '') || '')}</span></div>
                <div style={{ borderBottom: '1px solid #f0f0f0', margin: '6px 0' }}></div>
                <div style={{ fontSize: 12, textAlign: 'center' }}>Volume(s)</div>
                <div style={{ color: '#595959', textAlign: 'center' }}>
                  {String((notaData?.volumes ?? '') || '')}
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <fieldset style={{ border: '1px solid #f0f0f0', borderRadius: 6, padding: 12 }}>
          <legend style={{ padding: '0 6px' }}>Imprimir as etiquetas</legend>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ height: 25, fontSize: 13 }}>De:</span>
            <InputNumber min={1} value={volInicio} onChange={setVolInicio} style={{ height: 25, fontSize: 13, flex: 1 }} />
            <span style={{ height: 25, fontSize: 13 }}>Até:</span>
            <InputNumber min={1} value={volFim} onChange={setVolFim} style={{ height: 25, fontSize: 13, flex: 1 }} />
          </div>
        </fieldset>
        <div style={{ marginTop: 12 }}>
          <Row gutter={[8, 8]} align="middle">
            <Col span={18}>
              <span style={{ color: reprintError ? '#ff4d4f' : 'transparent' }}>{reprintError || '.'}</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              <Button type="default" icon={<PrinterOutlined />} onClick={confirmarReimpressao} loading={reprinting} block>
                Reimprimir
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* Elementos de áudio ocultos para feedback */}
      <audio ref={okAudioElRef} id="ok_audio" controls preload="none" style={{ display: 'none' }}>
        <source src="/sound/ok.mp3" type="audio/mpeg" />
      </audio>
      <audio ref={nokAudioElRef} id="notok_audio" controls preload="none" style={{ display: 'none' }}>
        <source src="/sound/nok.mp3" type="audio/mpeg" />
      </audio>
      <audio id="audio" controls preload="none" style={{ display: 'none' }}>
        <source src="" type="audio/mpeg" />
      </audio>

      <Modal
        title={<span style={{ color: '#faad14' }}><SearchOutlined /> Atenção: Palavras Reservadas Encontradas</span>}
        open={obsAlertVisible}
        onCancel={() => setObsAlertVisible(false)}
        footer={[
          <Button key="close" type="primary" onClick={() => setObsAlertVisible(false)}>
            Entendi
          </Button>
        ]}
        width={600}
        centered
        zIndex={2000} // Garantir que fique acima de outros modais
      >
        <List
          itemLayout="vertical"
          dataSource={obsAlertData}
          renderItem={(item) => (
            <List.Item key={item.id || item.Palavra || item.palavra}>
              <List.Item.Meta
                title={<Tag color="orange" style={{ fontSize: '14px' }}>{item.palavra || item.Palavra}</Tag>}
                description={
                  <div style={{
                    backgroundColor: '#fffbe6',
                    padding: '12px',
                    borderRadius: '4px',
                    borderLeft: '4px solid #faad14',
                    marginTop: '8px',
                    fontStyle: 'italic',
                    color: '#856404'
                  }}>
                    "...{item.textoEncontrado}..."
                  </div>
                }
              />
            </List.Item>
          )}
        />
      </Modal>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'chave',
            label: 'Chave',
            children: (
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>
                  Chave da Nf-e
                </label>
                <form
                  onSubmit={(e) => { e.preventDefault(); }}
                  style={{ display: 'flex', gap: 8, marginBottom: 8 }}
                >
                  <Input
                    ref={inputRef}
                    name="txtchave"
                    id="txtchave"
                    type="search"
                    value={chaveNfe}
                    onChange={(e) => setChaveNfe(e.target.value.replace(/\s+/g, ''))}

                    onBlur={async () => {
                      if (ignoreNextBlurRef.current) {
                        // Ignorar blur causado por .blur() programático em executarBusca
                        ignoreNextBlurRef.current = false;
                        return;
                      }
                      const value = chaveNfe?.replace(/\s+/g, '');
                      if (value && value.length >= 44) {
                        try {
                          const dados = await extraidadosdachave(value);
                          const nf = new NotaFiscal(value, dados.cnpj || '', dados.nota || '', dados.serie || '');
                          await setNotaFiscalData(nf);
                          if (nf.isValid()) {
                            try {
                              setNotaData((prev) => ({
                                ...(prev || {}),
                                chave: value,
                                nota: dados.nota ?? prev?.nota,
                                serie: dados.serie ?? prev?.serie,
                                cnpjrmte: dados.cnpj ?? prev?.cnpjrmte,
                              }));
                            } catch { }
                            setChaveNfe(value);
                            processaLeitura(nf)
                          }
                        } catch (e) {
                          console.warn('Falha no onBlur da chave:', e);
                        }
                      }
                    }}
                    placeholder="Digite a chave da NF-e"
                    style={{ flex: 1 }}
                    inputMode="search"
                    enterKeyHint="go"
                    onPressEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    autoComplete="off"
                    maxLength={44}
                  />
                  <Button
                    type="primary"
                    icon={<BarcodeOutlined />}
                    onClick={ler}
                    //onMouseDown={unlockAudioPlayback}
                    style={{ backgroundColor: '#5b5bff' }}
                    title="Escanear código de barras"
                  >
                  </Button>
                </form>

                <div style={{ marginBottom: 10 }}>
                  <Checkbox
                    checked={leituraContinua}
                    onChange={(e) => setLeituraContinua(e.target.checked)}
                    style={{ marginRight: 16 }}
                  >
                    Leitura contínua
                  </Checkbox>

                  <Checkbox
                    checked={adicionarLista}
                    onChange={(e) => setAdicionarLista(e.target.checked)}
                    style={{ display: 'none' }}
                  >
                    Adicionar a lista
                  </Checkbox>
                </div>

                {/* Renderizar  card dados Aba Chave*/}
                {notaData && (() => {
                  return <DadosCard info={notaData} />;
                })()}
              </div>
            )
          },
          {
            key: 'numero',
            label: 'Número NF',
            children: (
              <div>
                <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
                  Buscar por CNPJ, Nota e Série
                </label>
                <div style={{ marginBottom: 16 }}>
                  <Row gutter={[8, 8]}>
                    <Col span={10}>
                      <Input
                        placeholder="CNPJ (somente números)"
                        value={cnpjNumero}
                        onChange={(e) => setCnpjNumero(e.target.value)}
                        inputMode="numeric"
                        autoComplete="off"
                        maxLength={18}
                        prefix={<SearchOutlined />}
                      />
                    </Col>
                    <Col span={6}>
                      <Input
                        placeholder="Nota Inicial"
                        value={notaNumero}
                        onChange={(e) => setNotaNumero(e.target.value)}
                        inputMode="numeric"
                        autoComplete="off"
                      />
                    </Col>
                    <Col span={6}>
                      <Input
                        placeholder="Nota Final (opcional)"
                        value={notaFinalNumero}
                        onChange={(e) => setNotaFinalNumero(e.target.value)}
                        inputMode="numeric"
                        autoComplete="off"
                      />
                    </Col>
                    <Col span={2}>
                      <Input
                        placeholder="Série"
                        value={serieNumero}
                        onChange={(e) => setSerieNumero(e.target.value)}
                        inputMode="numeric"
                        autoComplete="off"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]} style={{ marginTop: 8 }}>
                    <Col span={14}>
                      <DatePicker.RangePicker
                        style={{ width: '100%' }}
                        placeholder={['Data Inicial', 'Data Final']}
                        value={[dataInicial, dataFinal]}
                        onChange={(dates) => {
                          setDataInicial(dates ? dates[0] : null);
                          setDataFinal(dates ? dates[1] : null);
                        }}
                        format="DD/MM/YYYY"
                      />
                    </Col>
                    <Col span={10}>
                      <Button
                        type="primary"
                        onClick={handleBuscarDinamico}
                        loading={isSearching}
                        style={{ backgroundColor: '#5b5bff', width: '100%' }}
                        icon={<SearchOutlined />}
                      >
                        Buscar Notas
                      </Button>
                    </Col>
                  </Row>
                </div>

                {/* Lista de Notas Encontradas */}
                {notasEncontradas.length > 0 && (() => {
                  const uniqueCDs = [...new Set(notasEncontradas.map(n => n.detalhe?.cd || n.rota?.cd || '').filter(Boolean))].sort();
                  const uniqueRotas = [...new Set(notasEncontradas.map(n => n.detalhe?.rota || n.rota?.rota || '').filter(Boolean))].sort();
                  const uniqueUFs = [...new Set(notasEncontradas.map(n => n.cidade?.uf || n.rota?.uf || '').filter(Boolean))].sort();

                  return (
                    <div style={{ marginBottom: 16, border: '1px solid #f0f0f0', borderRadius: 4 }}>
                      <Table
                        size="small"
                        dataSource={notasEncontradas}
                        rowKey={(record) => record.nota?.chave || record.chave || Math.random().toString()}
                        pagination={false}
                        scroll={{ x: 800, y: 300 }}
                        onRow={(record) => ({
                          onClick: () => {
                            const n = record.nota || {};
                            const d = record.detalhe || {};
                            const dest = record.destinatario || {};
                            const cid = record.cidade || {};
                            const rotaInfo = record.rota || null;

                            const composed = {
                              chave: n.chave || record.chave || '',
                              nota: n.nota,
                              serie: n.serie,
                              pedido: n.pedido || '',
                              volumes: Number(n.volumes ?? d.volumes ?? 0),
                              peso: Number(n.peso ?? 0),
                              m3: Number(n.m3 ?? 0),
                              nr1: d.nr1 ?? 0,
                              nr2: d.nr2 ?? 0,
                              status: Number(d.status ?? 0),
                              cdremetente: n.cdremetente,
                              remetente: n.remetente?.nome || '',
                              destinatario: dest.nome || '',
                              endereco: dest.endereco || '',
                              nro: (typeof d.nro === 'number' ? d.nro : (typeof dest.nro === 'number' ? dest.nro : null)),
                              cidade: cid.nome ? `${cid.nome}-${cid.uf || ''}` : '',
                              cep: n.cepentrega || '',
                              cd: d.cd || (rotaInfo?.cd || ''),
                              rota: d.rota || (rotaInfo?.rota || ''),
                              setor: rotaInfo?.setor ?? null,
                            };
                            setNotaData(composed);
                            const cleanChave = (n.chave || record.chave || '').replace(/\s+/g, '');
                            setChaveNfe(cleanChave);
                            setShowAddListButton(true);

                            // Toggle seleção ao clicar na linha
                            const recordKey = record.nota?.chave || record.chave;
                            setSelectedNotas(prev => {
                              const isSelected = prev.some(item => (item.nota?.chave || item.chave) === recordKey);
                              if (isSelected) {
                                return prev.filter(item => (item.nota?.chave || item.chave) !== recordKey);
                              } else {
                                return [...prev, record];
                              }
                            });
                          },
                          style: { cursor: 'pointer' }
                        })}
                        rowSelection={{
                          type: 'checkbox',
                          fixed: true,
                          selectedRowKeys: selectedNotas.map(n => n.nota?.chave || n.chave),
                          onChange: (_, selectedRows) => {
                            setSelectedNotas(selectedRows);
                          },
                        }}
                        columns={[
                          {
                            title: 'Nota',
                            dataIndex: ['nota', 'nota'],
                            key: 'nota',
                            width: 100,
                            fixed: 'left',
                            sorter: (a, b) => (a.nota?.nota || '').localeCompare(b.nota?.nota || ''),
                          },
                          {
                            title: 'Série',
                            dataIndex: ['nota', 'serie'],
                            key: 'serie',
                            width: 80,
                            sorter: (a, b) => (a.nota?.serie || '').localeCompare(b.nota?.serie || ''),
                          },
                          {
                            title: 'Destinatário',
                            dataIndex: ['destinatario', 'nome'],
                            key: 'destinatario',
                            width: 200,
                            ellipsis: true,
                            sorter: (a, b) => (a.destinatario?.nome || '').localeCompare(b.destinatario?.nome || ''),
                          },
                          {
                            title: 'M3',
                            key: 'm3',
                            width: 80,
                            render: (_, record) => (record.nota?.m3 ?? 0),
                            sorter: (a, b) => (a.nota?.m3 ?? 0) - (b.nota?.m3 ?? 0),
                          },
                          {
                            title: 'CD',
                            key: 'cd',
                            width: 90,
                            render: (_, record) => record.detalhe?.cd || record.rota?.cd || '',
                            filters: uniqueCDs.map(val => ({ text: val, value: val })),
                            onFilter: (value, record) => (record.detalhe?.cd || record.rota?.cd || '') === value,
                            sorter: (a, b) => (a.detalhe?.cd || a.rota?.cd || '').localeCompare(b.detalhe?.cd || b.rota?.cd || ''),
                          },
                          {
                            title: 'Rota',
                            key: 'rota',
                            width: 100,
                            render: (_, record) => record.detalhe?.rota || record.rota?.rota || '',
                            filters: uniqueRotas.map(val => ({ text: val, value: val })),
                            onFilter: (value, record) => (record.detalhe?.rota || record.rota?.rota || '') === value,
                            sorter: (a, b) => (a.detalhe?.rota || a.rota?.rota || '').localeCompare(b.detalhe?.rota || b.rota?.rota || ''),
                          },
                          {
                            title: 'UF',
                            key: 'uf',
                            width: 70,
                            render: (_, record) => record.cidade?.uf || record.rota?.uf || '',
                            filters: uniqueUFs.map(val => ({ text: val, value: val })),
                            onFilter: (value, record) => (record.cidade?.uf || record.rota?.uf || '') === value,
                            sorter: (a, b) => (a.cidade?.uf || a.rota?.uf || '').localeCompare(b.cidade?.uf || b.rota?.uf || ''),
                          },
                        ]}
                      />
                    </div>
                  );
                })()}

                {selectedNotas.length > 0 && (
                  <Button
                    type="primary"
                    onClick={handleAdicionarSelecionadas}
                    loading={isSearching}
                    block
                    style={{ marginBottom: 16, backgroundColor: '#52c41a' }}
                  >
                    Adicionar {selectedNotas.length} nota(s) selecionada(s)
                  </Button>
                )}

                {/* Renderizar  card dados Aba numero nf*/}
                {notaData && (() => {
                  return <DadosCard info={notaData} />;
                })()}

              </div>
            )
          },
          {
            key: 'manual',
            label: 'Manual',
            children: (
              <div>
                <div className="dados-container" style={{ marginBottom: 16 }}>
                  <div className="dados-heading">Dados do Remetente</div>
                  <Row gutter={12}>
                    <Col span={10}>
                      <label>CNPJ</label>
                      <Input
                        id="txt-cnpj-rmte-manual"
                        placeholder="CNPJ Remetente"
                        value={cnpjManual}
                        onChange={(e) => setCnpjManual(e.target.value)}
                        maxLength={18}
                      />
                    </Col>
                    <Col span={8}>
                      <label>Nota</label>
                      <Input
                        id="txt-nota-rmte-manual"
                        placeholder="Nº Nota"
                        value={notaManual}
                        onChange={(e) => setNotaManual(e.target.value)}
                      />
                    </Col>
                    <Col span={6}>
                      <label>Série</label>
                      <Input
                        id="txt-serie-rmte-manual"
                        placeholder="Série"
                        value={serieManual}
                        onChange={(e) => setSerieManual(e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>

                <div className="dados-container" style={{ marginBottom: 16 }}>
                  <div className="dados-heading">Dados do Destinatário</div>
                  <Row gutter={12}>
                    <Col span={14}>
                      <label>CNPJ</label>
                      <Input
                        placeholder="CNPJ Destinatário"
                        value={cnpjDestManual}
                        onChange={(e) => setCnpjDestManual(e.target.value)}
                        maxLength={18}
                      />
                    </Col>
                    <Col span={10}>
                      <label>CEP</label>
                      <Input
                        placeholder="CEP"
                        value={cepDestManual}
                        onChange={(e) => {
                          setCepDestManual(e.target.value);
                          if (cepInvalido) setCepInvalido(false);
                        }}
                        style={cepInvalido ? { borderColor: 'red', borderWidth: '2px' } : {}}
                        maxLength={9}
                      />
                    </Col>
                  </Row>
                </div>

                <div className="dados-container" style={{ marginBottom: 16 }}>
                  <div className="dados-heading">Dados da Mercadoria</div>
                  <Row gutter={12}>
                    <Col span={8}>
                      <label>Volumes</label>
                      <Input
                        placeholder="Qtd"
                        value={volumesManual}
                        onChange={(e) => setVolumesManual(e.target.value)}
                        type="number"
                      />
                    </Col>
                    <Col span={8}>
                      <label>Peso Bruto</label>
                      <Input
                        placeholder="Peso"
                        value={pesoManual}
                        onChange={(e) => setPesoManual(e.target.value)}
                        type="number"
                      />
                    </Col>
                    <Col span={8}>
                      <label>Pedido</label>
                      <Input
                        placeholder="Opcional"
                        value={pedidoManual}
                        onChange={(e) => setPedidoManual(e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>

                <Button
                  type="primary"
                  onClick={handleBuscarManual}
                  loading={isSearching}
                  block
                  style={{ backgroundColor: '#5b5bff', marginBottom: 16 }}
                >
                  Buscar
                </Button>

                {/* Renderizar card dados Aba Manual */}
                {notaData && activeTab === 'manual' && (() => {
                  return <DadosCard info={notaData} />;
                })()}
              </div>
            )
          }
        ]}
      />




      <BarcodeScannerModal
        visible={scannerVisible}
        onDetected={handleScanResult}
        onClose={handleCloseScannerModal}
      />
      <NotaManutencaoModal
        open={manutencaoVisible}
        onClose={() => setManutencaoVisible(false)}
        chave={notaData?.chave}
        nota={notaData?.nota}
        pedido={notaData?.pedido}
        volumesAntes={notaData?.volumes}
        cepAntes={String(notaData?.cep || '')}
        enderecoAntes={notaData?.logradouro || notaData?.endereco}
        nroAntes={notaData?.nro}
        cnpjRemetente={notaData?.cnpjrmte}
        newCepInfo={cepInfoModal}
        onBuscarCep={async (cep) => {
          try {
            const cepDigits = String(cep).replace(/\D/g, '').slice(0, 8);
            const [rota, siscep] = await Promise.allSettled([
              admin.getRotasByCep(cepDigits),
              admin.getSisrotasByCep(cepDigits)
            ]);

            const rotaData = rota.status === 'fulfilled' ? rota.value : null;
            const siscepData = siscep.status === 'fulfilled' ? siscep.value : null;

            const info = {
              cep: cepDigits,
              cidade: String(siscepData?.dslocal || ''),
              uf: String(rotaData?.uf || siscepData?.dsuf || ''),
              praca: String(rotaData?.rota || ''),
              cd: String(rotaData?.cd || ''),
              setor: typeof rotaData?.setor === 'number' ? rotaData.setor : undefined,
              logradouro: String(siscepData?.dslogradouro || ''),
              bairro: String(siscepData?.dsbairro || ''),
            };
            setCepInfoModal(info);
            return info;
          } catch (e) {
            const info = {
              cep: String(cep).replace(/\D/g, '').slice(0, 8),
              cidade: '',
              uf: '',
              praca: '',
              cd: '',
              setor: undefined
            };
            setCepInfoModal(info);
            return info;
          }
        }}
        onAlterarVolumes={async (chaveParam, depois, motivo) => {
          try {
            const chave = String(chaveParam || '');
            const volNum = parseInt(String(depois || '0'), 10);
            if (!volNum || volNum <= 0) {
              message.error('Volumes inválidos');
              return;
            }
            await apiService.patch('/v1/notas/detalhe', { chave, volumes: volNum, observacao: motivo });
            setNotaData(prev => prev ? { ...prev, volumes: String(volNum), alteracao: 'VOLUMES' } : prev);
            setUltimaAlteracao('VOLUMES');
            message.success('Volumes atualizados com sucesso');
            setManutencaoVisible(false);
          } catch (err) {
            message.error(String(err?.message || 'Falha ao atualizar volumes'));
          }
        }}
        onAlterarCep={async (chaveParam, cep, motivo, info) => {
          try {
            const chave = String(chaveParam || '');
            const cepDigits = String(cep || '').replace(/\D/g, '').slice(0, 8);
            const payload = {
              chave,
              cepentrega: cepDigits,
              logradouro: info?.logradouro,
              nro: info?.nro,
              rota: String(info?.praca || '').slice(0, 4) || null,
              cd: String(info?.cd || ''),
              setor: typeof info?.setor === 'number' ? info.setor : undefined,
              observacao: motivo,
            };
            await apiService.patch('/v1/notas/detalhe', payload);
            setNotaData(prev => prev ? {
              ...prev,
              cidade: info?.cidade ?? prev?.cidade,
              cep: payload.cepentrega,
              logradouro: payload.logradouro ?? prev.logradouro,
              endereco: payload.logradouro ?? prev.endereco,
              nro: payload.nro ?? prev.nro,
              rota: payload.rota ?? prev.rota,
              cd: payload.cd,
              setor: payload.setor ?? prev.setor,
              alteracao: 'CEP',
            } : prev);
            setUltimaAlteracao('CEP');
            message.success('CEP e rota atualizados com sucesso');
            setManutencaoVisible(false);
          } catch (err) {
            message.error(String(err?.message || 'Falha ao atualizar CEP'));
          }
        }}
      />
    </Modal>
  );
};

export default InclusaoNotasModal;
